import {FlagProps} from 'platform/components';
import {match} from 'ts-pattern';

import {ServiceAccountStatus} from '@dms/api/security';
import i18n from '@dms/i18n';

type ServiceAccountStatusFlagProps = Pick<FlagProps, 'label' | 'colorScheme'>;

export function getServiceAccountStatusFlagProps(
  status: ServiceAccountStatus
): ServiceAccountStatusFlagProps {
  return match<ServiceAccountStatus, ServiceAccountStatusFlagProps>(status)
    .with('active', () => ({
      label: i18n.t('entity.serviceAccount.status.active'),
      colorScheme: 'green',
    }))
    .with('inactive', () => ({
      label: i18n.t('entity.serviceAccount.status.inactive'),
      colorScheme: 'red',
    }))
    .with('deleted', () => ({
      label: i18n.t('entity.serviceAccount.status.deleted'),
      colorScheme: 'neutral',
    }))
    .exhaustive();
}
